import React from "react";
import withStyles from "react-jss";
import classNames from "classnames";

const styles = theme => ({
    root: {
        padding: "20px",
        backgroundColor: theme.palette.colors.white,
        border: `solid 1px ${theme.palette.colors.disabled}`,
        borderRadius: "20px",
        "& *": {
            fontSize: "16px",
            lineHeight: "1.38",
            color: theme.palette.colors.darkSlateBlue,
            fontFamily: theme.fonts.light,
        },
    },
    styleNone: {
        "& ul": {
            listStyle: "none",
        },
        "& ol": {
            listStyle: "none",
        },
    },
    [`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
        root: {
            "& *": {
                fontSize: "14px",
                lineHeight: "1.57",
            },
        },
    },
    [`@media (max-width: ${theme.media.sm})`]: {
        root: {
            "& *": {
                fontSize: "14px",
                lineHeight: "1.57",
            },
        },
    },
});

class HtmlEditableBlock extends React.Component {
    render() {
        let classes = this.props.classes;
        return (
            <div
                className={classNames(classes.root,{
                    [classes.styleNone]: this.props.styleNone
                })}
                dangerouslySetInnerHTML={{
                    __html: this.props.text,
                }}
            ></div>
        );
    }
}

export default withStyles(styles)(HtmlEditableBlock);
